// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"266":"8479318d","437":"21572a4d","619":"ddff8fd8","829":"a0fb5ef1"}[chunkId] + ".js";
};